var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('ul',[_vm._m(0),_vm._l((_vm.list),function(li,index){return _c('li',{key:'tab_link_' + index},[_c('router-link',{attrs:{"to":li.url}},[_vm._v(_vm._s(li.text))])],1)}),_c('li',[_vm._v(_vm._s(_vm.getCurrentPage))])],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":"/"}},[_vm._v("Games")])])
}]

export { render, staticRenderFns }